import { render, staticRenderFns } from "./HelpDesk.vue?vue&type=template&id=01b0949a&scoped=true&"
import script from "./HelpDesk.vue?vue&type=script&lang=js&"
export * from "./HelpDesk.vue?vue&type=script&lang=js&"
import style0 from "./HelpDesk.vue?vue&type=style&index=0&id=01b0949a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b0949a",
  null
  
)

export default component.exports